import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getWishList } from "@insite/client-framework/Services/WishListService";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddWishListToCart";
import { setGA4Event } from "@tggstore/Handlers/Utilities/CustomTracking";
import loadProductCategories from "@tggstore/Store/Handlers/Custom/LoadProductCategories";
import { CustomState } from "@tggstore/Store/Reducers";

addToChainAfter(chain, ExecuteOnSuccessCallback, async props => {
    const state = props.getState() as CustomState;
    const session = state.context.session;
    const cartState = getCurrentCartState(state).value;
    const cartlines = props.apiResult.cartLines;

    const { wishListLineCollection } = await getWishList({
        wishListId: props.apiParameter.wishListId,
        expand: ["getAllLines"],
    });

    const currency = session?.currency?.currencyCode || "";
    const billToCustomerName = getBillToState(state, cartState?.billToId)?.value?.customerNumber ?? "";

    if (wishListLineCollection && wishListLineCollection.length > 0) {
        const productIds = wishListLineCollection.map(o => o.productId).filter((id): id is string => id !== null);

        // we replace the pricing object from the wishListLineCollection with the pricing object from the cartlines
        // so we can get the correct price for the product for each line
        wishListLineCollection.forEach((line: any) => {
            const cartLine = cartlines?.find((cartLine: any) => cartLine.productId === line.productId);
            if (cartLine) {
                line.pricing = cartLine.pricing;
            }
        });

        const wishListLineCollectionSubTotal = parseFloat(
            wishListLineCollection
                .reduce((acc, line) => {
                    const price = line.pricing?.actualPrice ?? 0;
                    const qty = line.qtyOrdered ?? 0;
                    return acc + price * qty;
                }, 0)
                .toFixed(2),
        );

        props.dispatch(
            loadProductCategories({
                productIds,
                type: "cart",
                onSuccess: data => {
                    setGA4Event(wishListLineCollection, "add_to_cart", {
                        currency,
                        value: wishListLineCollectionSubTotal,
                        affiliation: state.customDefaultWarehouse.warehouse?.description || "",
                        account_number: billToCustomerName,
                        productCategories: data,
                    });
                },
            }),
        );
    }
});
